import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Container, ChevronDown, ChevronUp } from 'lucide-react';

export const EMPTY_SHIPPING = {
  shipper: '', consignee: '', obl_no: '', hbl_no: '', pol: '', pod: '', etd: '', eta: '',
  contents: '', gross_weight: '', charge_weight: '', no_of_pkgs: '', volume: '',
  qty_20: '', qty_40: '', qty_45: '', qty_40hc: '',
  mother_vessel: '', feeder_vessel: '', container_no: '', job_no: '', your_ref: '',
};

export const cleanShipping = (s) => {
  const filled = Object.fromEntries(Object.entries(s || {}).filter(([, v]) => String(v || '').trim() !== ''));
  return Object.keys(filled).length ? filled : null;
};

const FIELDS = [
  ['shipper', 'Shipper'], ['consignee', 'Consignee'],
  ['container_no', 'Container No.'], ['job_no', 'Job No.'],
  ['obl_no', 'OBL No.'], ['hbl_no', 'HBL No.'],
  ['pol', 'POL (Port of Loading)'], ['pod', 'POD (Port of Discharge)'],
  ['etd', 'ETD'], ['eta', 'ETA'],
  ['contents', 'Contents'], ['your_ref', 'Your Ref No.'],
  ['gross_weight', 'Gross Weight'], ['charge_weight', 'Charge Weight'],
  ['no_of_pkgs', 'No. of PKGS'], ['volume', 'Volume'],
  ['qty_20', "20' Qty"], ['qty_40', "40' Qty"],
  ['qty_45', "45' Qty"], ['qty_40hc', '40HC Qty'],
  ['mother_vessel', 'Mother Vessel / Voyage'], ['feeder_vessel', 'Feeder Vessel / Voyage'],
];

export const ShippingInfoCard = ({ value, onChange }) => {
  const hasData = Object.values(value || {}).some((v) => String(v || '').trim() !== '');
  const [open, setOpen] = useState(hasData);
  const v = { ...EMPTY_SHIPPING, ...(value || {}) };

  return (
    <Card className="mb-6 border-cyan-200" data-testid="shipping-info-card">
      <CardHeader className="pb-3 cursor-pointer" onClick={() => setOpen(!open)} data-testid="shipping-info-toggle">
        <CardTitle className="text-base flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Container size={18} className="text-cyan-700" />
            Container / Shipping Details
            <span className="text-sm font-normal text-gray-400">(optional — fill for container trucking jobs)</span>
          </span>
          <Button type="button" variant="ghost" size="sm">{open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</Button>
        </CardTitle>
      </CardHeader>
      {open && (
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {FIELDS.map(([key, label]) => (
              <div key={key}>
                <Label className="text-xs text-gray-500">{label}</Label>
                <Input
                  value={v[key]}
                  onChange={(e) => onChange({ ...v, [key]: e.target.value })}
                  data-testid={`shipping-${key}`}
                  className="h-9"
                />
              </div>
            ))}
          </div>
          <p className="text-xs text-gray-400 mt-3">
            When any field is filled, the invoice PDF switches to the container tax invoice layout and the DO PDF shows a Container/Shipping section.
          </p>
        </CardContent>
      )}
    </Card>
  );
};
